// extracted by mini-css-extract-plugin
export default {"header":"DT-z","isActive":"ET-z"};